/* unplugin-vue-components disabled */import { render } from "./falv.vue?vue&type=template&id=5ca3c94d&scoped=true"
const script = {}

import "./falv.vue?vue&type=style&index=0&id=5ca3c94d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ca3c94d"]])

export default __exports__